import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController, ToastController } from '@ionic/angular';
import { LoaderComponent } from '../loader/loader.component';
import { ESignService } from 'src/app/services/esign-service.service';

@Component({
  selector: 'app-secure-verify-esign',
  template: '<div class="grid col-12"></div>'
})
export class VerifyEsignComponent implements OnInit {
  progressSpinnerDialog: any = null;
  esignKey: number;
  esignType: string;

  constructor(private route: ActivatedRoute, 
    private esignService: ESignService, 
    private dialog: MatDialog, 
    private router: Router,
    private modalCtrl: ModalController, 
    private toastController: ToastController) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: HttpParams) => {
      this.esignKey = +params['esignKey'];
      this.esignType = params['esignType'];

      this.loadData();
    });
  }
  
  loadData() {
    this.displayProgressSpinner();
    this.fetchEsignDoc();
  }

  async displayProgressSpinner() {
    this.progressSpinnerDialog = this.dialog.open(LoaderComponent, {
      disableClose: true,
      panelClass: "progressSpinner",
    });
  }

  fetchEsignDoc() {
    this.esignService
    .fetchEsignReceipt(this.esignType, this.esignKey)
    .subscribe(async ({status, depKey, esignType, errorMessage}) => {
      if(status === 'SUCCESS') {
        this.progressSpinnerDialog.close();
        console.log('Esign Receipt');
        this.esignService.successToast("Esign Successful.");

        if(esignType === 'PRO_APPROVAL') {
          this.router.navigate(['/secure', 'pro-approver-list'], { replaceUrl: true });
        }

        else if(esignType === 'NOC_APPROVAL') {
          this.router.navigate(['/secure', 'noc-approver-list'], { replaceUrl: true });
        }

        else if(esignType === 'CASTE_VALIDITY_REF_LETTER') {
          this.router.navigate(['/secure', 'caste-val-ref-letter-approver-list'], { replaceUrl: true });
        }
      }
      else {
        this.progressSpinnerDialog.close();
        const toast = await this.toastController.create({
          message: errorMessage,
          icon: "information-circle",
          position: "top",
          cssClass: "toast error-toast",
          duration: 4000,
        });
        toast.present();
        
        if(esignType === 'PRO_APPROVAL') {
          this.router.navigate(['/secure', 'pro-approver-dtl', depKey], { replaceUrl: true });
        }

        else if(esignType === 'NOC_APPROVAL') {
          this.router.navigate(['/secure', 'noc-approver-dtl', depKey], { replaceUrl: true });
        }

        else if(esignType === 'CASTE_VALIDITY_REF_LETTER') {
          this.router.navigate(['/secure', 'caste-val-ref-letter-approver-dtl', depKey], { replaceUrl: true });
        }
      }
    }, error => {
      this.progressSpinnerDialog.close();
      if(this.esignType === 'PRO_APPROVAL') {
        this.router.navigate(['/secure', 'pro-approver-list'], { replaceUrl: true });
      }

      else if(this.esignType === 'NOC_APPROVAL') {
        this.router.navigate(['/secure', 'noc-approver-list'], { replaceUrl: true });
      }

      else if(this.esignType === 'CASTE_VALIDITY_REF_LETTER') {
        this.router.navigate(['/secure', 'caste-val-ref-letter-approver-list'], { replaceUrl: true });
      }
    });
  }
}
